import React from "react";
import ProformaInvoices from "pages/ProformaInvoices";

const Index = () => (
  <ProformaInvoices
    pageTitle="سفارش‌های تأیید واریزی شده"
    totalLabel="سفارش‌های تأیید واریزی شده"
    emptyText="سفارشی بدون واریزی معلق وجود ندارد"
    showCreateButton={false}
    orderStatus={null}
    section="allOrders"
    paymentConfirmation="confirmed"
    showFilters
    showDateColumn
    mobileColumns={2}
  />
);

export default Index;
